import React from 'react';
import './SharedCaptchaCard.css';

function RobotIcon() {
  return (
    <svg className="scap-robot" viewBox="0 0 48 58" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <rect x="10" y="8" width="28" height="20" rx="6" fill="currentColor" />
      <path d="M16 8v-6 M32 8v-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <circle cx="16" cy="2" r="2" fill="currentColor" />
      <circle cx="32" cy="2" r="2" fill="currentColor" />
      <circle cx="16" cy="16" r="2.5" fill="#fff" />
      <circle cx="32" cy="16" r="2.5" fill="#fff" />
      <rect x="8" y="30" width="32" height="22" rx="5" fill="currentColor" />
    </svg>
  );
}

/**
 * Единый UI капчи (как VintedStripe1): иконка, заголовки, вопрос с API, поле ответа, кнопка.
 * @param {'page'|'inline'} variant — page: полноэкранный фон; inline: блок внутри формы
 */
export default function SharedCaptchaCard({
  variant = 'page',
  labels,
  question,
  answer,
  onAnswerChange,
  onVerify,
  verifyLoading,
  error,
  sessionReady = true,
}) {
  const inner = (
    <div className={`scap-card ${variant === 'inline' ? 'scap-card--inline' : ''}`}>
      <div className="scap-icon" aria-hidden>
        <RobotIcon />
      </div>
      <h1 className="scap-title">{labels.title}</h1>
      <p className="scap-subtitle">{labels.subtitle}</p>

      {!sessionReady ? (
        <>
          <p className="scap-loading">{labels.loading}</p>
          {error ? <p className="scap-error">{error}</p> : null}
        </>
      ) : question ? (
        <>
          <p className="scap-question">{question}</p>
          <input
            type="text"
            className="scap-input"
            value={answer}
            onChange={(e) => onAnswerChange(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && onVerify()}
            placeholder={labels.answerPlaceholder}
            autoComplete="off"
            aria-label={labels.answerPlaceholder}
          />
          {error ? <p className="scap-error">{error}</p> : null}
          <button
            type="button"
            className="scap-btn"
            onClick={onVerify}
            disabled={verifyLoading || !answer.trim()}
          >
            {verifyLoading ? labels.processing : labels.continue}
          </button>
        </>
      ) : (
        <>
          <p className="scap-loading">{labels.loading}</p>
          {error ? <p className="scap-error">{error}</p> : null}
        </>
      )}

      <p className="scap-footer">{labels.footer}</p>
    </div>
  );

  if (variant === 'inline') {
    return <div className="scap-inline-wrap">{inner}</div>;
  }

  return (
    <div className="scap-page">
      {inner}
    </div>
  );
}
